import { Button } from "@/components/ui/button";
import { m } from "@/paraglide/messages";

export interface TypingResultsProps {
  wpm: number;
  accuracy: number;
  correct: number;
  incorrect: number;
  onRestart: () => void;
}

export function TypingResults({
  wpm,
  accuracy,
  correct,
  incorrect,
  onRestart,
}: TypingResultsProps) {
  return (
    <div className="space-y-6 text-center" aria-live="polite">
      <p className="font-display text-xs font-semibold uppercase tracking-[0.2em] text-secondary">
        {m.typing_done()}
      </p>

      <div className="flex flex-wrap items-end justify-center gap-10">
        <div>
          <div className="font-display text-5xl font-bold pct-result">
            {wpm}
          </div>
          <div className="mt-1 text-sm text-muted-foreground">
            {m.typing_stat_wpm()}
          </div>
        </div>
        <div>
          <div className="font-display text-5xl font-bold">{accuracy}%</div>
          <div className="mt-1 text-sm text-muted-foreground">
            {m.typing_stat_accuracy()}
          </div>
        </div>
      </div>

      <p className="text-sm text-muted-foreground">
        {m.typing_chars_summary({
          correct: String(correct),
          incorrect: String(incorrect),
        })}
      </p>

      <Button onClick={onRestart}>{m.typing_restart()}</Button>
    </div>
  );
}
